import { render, staticRenderFns } from "./BoskShortcutDatetime.vue?vue&type=template&id=07e04614"
import script from "./BoskShortcutDatetime.vue?vue&type=script&lang=js"
export * from "./BoskShortcutDatetime.vue?vue&type=script&lang=js"
import style0 from "./BoskShortcutDatetime.vue?vue&type=style&index=0&id=07e04614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports